import { memo, useCallback } from 'react';
import DateTimePopover from './datetime/components/DateTimePopover';
import { shouldShowPopovers } from '../v2/utils/shouldShowPopovers';
import { useObjectId } from '../v2/hooks/useObjectId';
import CRMPropertyDateTimeInput from '../datetime/CRMPropertyDateTimeInput';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isEmptyValue } from '../validation/utils/isEmptyValue';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyInputDateTime = props => {
  const {
    onChange,
    enablePopovers,
    onOpenChange
  } = props;
  useComponentMountMetric('PropertyInputDateTime');
  const currentValue = usePropertyValue();
  const objectId = useObjectId();
  const showPopover = shouldShowPopovers({
    enablePopovers,
    objectId
  });
  const applyChange = useCallback(value => {
    if (typeof onChange === 'function') {
      onChange(value == null ? syntheticEvent(null) : syntheticEvent(String(value)));
    }
    onOpenChange === null || onOpenChange === void 0 || onOpenChange(syntheticEvent(false));
  }, [onChange, onOpenChange]);
  const handleChange = useCallback(evt => applyChange(evt.target.value), [applyChange]);
  if (!showPopover) {
    return /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      gap: 8,
      children: [/*#__PURE__*/_jsx(CRMPropertyDateTimeInput, Object.assign({}, props, {
        value: currentValue,
        onChange: handleChange
      })), /*#__PURE__*/_jsx(Button, {
        use: "link",
        size: "small",
        onClick: () => applyChange(null)
        // isEmptyValue does not include null checking, so adding this here to check for all non-values
        ,
        disabled: isEmptyValue(currentValue) || currentValue === null,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.PropertyInputDateTime.clear"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(DateTimePopover, Object.assign({}, props, {
    applyChange: applyChange
  }));
};
export default /*#__PURE__*/memo(PropertyInputDateTime);